













































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, PropSync } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { FullState, RootGettersReturns } from '@/store/types';
import { BoardActionsKeys, BoardActionsPayload } from '@/store/types/board';
import { SessionActionsKeys, SessionStatus } from '@/store/types/session';
import { JitsiActionsKeys } from '@/store/types/jitsi';
import { ActiveItem, InterfaceActionsPayload, InterfaceActionsKeys } from '@/store/types/interface';
import CircleIcon from '../shared/CircleIcon.vue';
import { ClickOutside } from 'vuetify/lib';
import { ElementActionsKeys, ElementActionsPayload } from '@/store/types/element';
import { StageActionsKeys, StageActionsPayload } from '@/store/types/stageState';
import { externalConferenceLinkType } from '@/utils';

@Component({
  components: {
    Jitsi: () => import('./Jitsi.vue'),
    Minimap: () => import('./Minimap.vue'),
    SessionList: () => import('../Dashboard/SessionList.vue'),
    SessionContext: () => import('../Dashboard/SessionContext.vue'),
    Toolbar: () => import('./Toolbars/Toolbar.vue'),
    CanvasRightSidebar: () => import('./ShoutboxSidebar/CanvasRightSidebar.vue'),
    CircleIcon,
  },
  directives: {
    ClickOutside,
  },
})
export default class Interface extends Vue {
  @PropSync('activeAdditionalToolbar') activeAdditional!: boolean;
  @PropSync('activeDrawingColor') drawingColor!: string;
  @PropSync('activeDrawingThickness') drawingThickness!: string;
  @Prop(Function) modifyZoom!: (zoomIn: boolean, setScale?: number) => void;
  @Prop(Function) outerCanvasSize!: () => { width: number; height: number };
  @Prop(Function) activateLaserPointer!: () => void;
  @Prop(Function) deactivateLaserPointer!: () => void;

  @Getter boardName!: RootGettersReturns['boardName'];
  @Getter boardId!: RootGettersReturns['boardId'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sessionJoined!: RootGettersReturns['sessionJoined'];
  @Getter sessionStatus!: RootGettersReturns['sessionStatus'];
  @Getter sessionPin!: RootGettersReturns['sessionPin'];
  @Getter sessionExternalLink!: RootGettersReturns['sessionExternalLink'];
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter interfaceActiveItem!: RootGettersReturns['interfaceActiveItem'];
  @Getter interfaceLaserActive!: RootGettersReturns['interfaceLaserActive'];
  @Getter stageState!: RootGettersReturns['stageState'];
  @Getter openRightSidebar!: RootGettersReturns['openRightSidebar'];
  @Getter unseenShouts!: RootGettersReturns['unseenShouts'];
  @Getter haveUndo!: RootGettersReturns['haveUndo'];
  @Getter haveRedo!: RootGettersReturns['haveRedo'];
  @Getter raisedHand!: RootGettersReturns['raisedHand'];
  @Getter laserOffer!: RootGettersReturns['laserOffer'];
  @Getter laserOfferedTo!: RootGettersReturns['laserOfferedTo'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];
  @Getter isInvitedToExternalConference!: RootGettersReturns['isInvitedToExternalConference'];
  @Getter progressBars!: RootGettersReturns['progressBars'];

  @Action(BoardActionsKeys.RENAME_BOARD) renameBoard!: (payload: BoardActionsPayload['RENAME_BOARD']) => void;
  @Action(SessionActionsKeys.START_SESSION) startSession!: () => void;
  @Action(SessionActionsKeys.PAUSE_SESSION) pauseSession!: () => void;
  @Action(JitsiActionsKeys.START_MEET) startMeet!: () => void;
  @Action(JitsiActionsKeys.START_EXTERNAL_MEET) startExternalMeet!: () => Promise<void>;
  @Action(InterfaceActionsKeys.CHANGE_ACTIVE_ITEM) toolbarChangeActiveItem!: (
    payload: InterfaceActionsPayload['CHANGE_ACTIVE_ITEM']
  ) => void;
  @Action(InterfaceActionsKeys.CHANGE_LASER_ACTIVE) changeLaserActive!: (
    payload: InterfaceActionsPayload['CHANGE_LASER_ACTIVE']
  ) => void;
  @Action(InterfaceActionsKeys.SET_RIGHT_SIDEBAR) setRightSidebar!: (
    payload: InterfaceActionsPayload['SET_RIGHT_SIDEBAR']
  ) => void;
  @Action(ElementActionsKeys.UNDO) undo!: (payload: ElementActionsPayload['UNDO']) => void;
  @Action(ElementActionsKeys.REDO) redo!: (payload: ElementActionsPayload['REDO']) => void;
  @Action(StageActionsKeys.SEND_SHOUT) sendShout!: (payload: StageActionsPayload['SEND_SHOUT']) => void;
  @Action(StageActionsKeys.ACCEPT_POINTER) acceptPointer!: (payload: StageActionsPayload['ACCEPT_POINTER']) => void;
  @Action(StageActionsKeys.DECLINE_POINTER) declinePointer!: (payload: StageActionsPayload['DECLINE_POINTER']) => void;
  @Action(StageActionsKeys.TAKEAWAY_POINTER) takeawayPointer!: () => void;

  private newBoardName = '';
  private listSessions = false;
  drawingColors = [
    '#212121',
    '#9E9E9E',
    '#E0E0E0',
    '#F44336',
    '#FB8C00',
    '#FFC400',
    '#00796B',
    '#4CAF50',
    '#CEE742',
    '#9134A2',
    '#0D47A1',
    '#2196F3',
  ];
  drawingThicknesses = ['2', '3', '5', '7', '9', '11'];
  showMinimap = false;

  mounted() {
    this.newBoardName = this.boardName;
    ((this.$refs.nameInput as Vue).$el as HTMLElement).addEventListener('paste', this.onPaste);
    window.addEventListener('resize', this.calculateSizeOfTextInput);
    this.$nextTick(() => {
      if (this.isActiveInterfaceItem(ActiveItem.FREE_HAND)) {
        this.activeAdditional = true;
        const target = (this.$refs.free_hand_button as Vue).$el as HTMLElement;
        this.calculateHelperToolbarPosition(target);
      }
      this.calculateSizeOfTextInput();
    });
  }

  beforeDestroy() {
    ((this.$refs.nameInput as Vue).$el as HTMLElement).removeEventListener('paste', this.onPaste);
    window.removeEventListener('resize', this.calculateSizeOfTextInput);
  }

  onPaste(e: ClipboardEvent) {
    e.stopImmediatePropagation();
    e.stopPropagation();
  }

  get isUntitledBoard() {
    const regex = /Untitled Board \d{4}-\d{2}-\d{2}/;
    return regex.test(this.boardName);
  }

  @Watch('progressBars', { deep: true })
  progressBarsRestructured() {
    return Object.entries(this.progressBars).map(([key, value]) => ({
      id: key,
      percentage: value,
    }));
  }

  toastRaisedHands: {
    [key: string]: {
      id: number;
      name: string | undefined;
      closed: boolean;
      time: number;
    };
  } = {};

  @Watch('raisedHand', {
    immediate: true,
  })
  setToastRaisedHands(newVal: number[]) {
    Object.keys(this.toastRaisedHands).forEach(id => {
      if (!newVal.includes(Number(id))) {
        delete this.toastRaisedHands[id];
      }
    });
    const state = this.$store.state as FullState;

    newVal.forEach(uId => {
      if (!this.toastRaisedHands[uId]) {
        this.toastRaisedHands[uId] = {
          id: uId,
          name: state.Board.Session.users.find(u => u.id === uId)?.fullName,
          closed: false,
          time: new Date().getTime(),
        };
      }
    });

    this.toastRaisedHands = {
      ...this.toastRaisedHands,
    };
  }

  get raiseHands() {
    return Object.values(this.toastRaisedHands)
      .filter(chip => !chip.closed)
      .sort((a, b) => b.time - a.time);
  }

  closeChip(uId: string) {
    this.toastRaisedHands[uId] = {
      ...this.toastRaisedHands[uId],
      closed: true,
    };
    this.toastRaisedHands = { ...this.toastRaisedHands };
  }

  isRaisedHand = false;
  raisedHandDisabled = false;
  raiseHandTimer = 30 * 1000;

  toggleRaiseHand() {
    this.isRaisedHand ? this.lowerHand() : this.raiseHand();
  }

  raiseHand() {
    this.isRaisedHand = true;
    this.sendShout(`:/raise_hand-true/:`);
    setTimeout(() => {
      if (this.isRaisedHand) {
        this.lowerHand();
      }
    }, this.raiseHandTimer);
  }

  lowerHand() {
    this.isRaisedHand = false;
    this.sendShout(`:/raise_hand-false/:`);
    this.disableRaiseHand();
  }

  disableRaiseHand() {
    this.raisedHandDisabled = true;
    setTimeout(() => {
      this.raisedHandDisabled = false;
    }, this.raiseHandTimer);
  }

  get externalVideoIcon() {
    return externalConferenceLinkType(this.sessionExternalLink);
  }

  get externalLink() {
    if (!this.sessionExternalLink) return '';
    const haveProtocol = (this.sessionExternalLink?.split('://') || []).length > 1;
    return haveProtocol ? this.sessionExternalLink : `https://${this.sessionExternalLink}`;
  }

  async startExternalVideo() {
    if (!this.isGuest) {
      await this.startExternalMeet();
      window.open(this.externalLink, '_blank');
    } else {
      this.joinLink();
    }
  }

  showExternal = true;

  joinLink() {
    window.open(this.externalLink, '_blank');
    this.showExternal = false;
  }

  declineLink() {
    this.showExternal = false;
  }

  jitsiDialog = false;

  startJitsiMeet() {
    if (this.externalLink) {
      this.jitsiDialog = true;
    } else {
      this.startMeet();
    }
  }

  nameChanged() {
    if (this.newBoardName.length && this.newBoardName !== this.boardName) {
      this.renameBoard({
        boardId: this.boardId,
        name: this.newBoardName,
      });
      this.calculateSizeOfTextInput();
    } else {
      this.newBoardName = this.boardName;
      this.calculateSizeOfTextInput();
    }
  }

  toggleSession() {
    if (!this.sessionRunning) {
      this.startSession();
    } else {
      this.pauseSession();
    }
  }

  calculateSizeOfTextInput() {
    const span = document.createElement('span');
    span.innerText = this.boardName;
    span.style.width = 'auto';
    span.style.position = 'absolute';
    span.style.lineHeight = '20px';
    span.style.fontSize = '16px';
    span.style.fontFamily = 'Avenir, Helvetica, Arial, sans-serif;';

    document.body.append(span);
    // debugger;
    const width = Math.max(span.clientWidth + 110, 125);
    span.remove();
    const maxSize =
      this.outerCanvasSize().width - (document.querySelector('.top-right-interface')?.clientWidth || 0) - 8 * 16;
    ((this.$refs.nameInput as Vue).$el as HTMLElement).style.width = `${width}px`;
    ((this.$refs.nameInput as Vue).$el as HTMLElement).style.maxWidth = `${maxSize}px`;
  }

  @Watch('boardName')
  updateBoardName() {
    this.newBoardName = this.boardName;
    this.calculateSizeOfTextInput();
  }

  get sessionRunning() {
    return this.sessionStatus === SessionStatus.STARTED;
  }

  isActiveInterfaceItem(item: ActiveItem) {
    return this.interfaceActiveItem === item;
  }

  changeActiveItem(payload: InterfaceActionsPayload['CHANGE_ACTIVE_ITEM']) {
    if (payload !== ActiveItem.FREE_HAND && payload !== ActiveItem.ERASER) {
      this.activeAdditional = false;
    }
    this.toolbarChangeActiveItem(payload);
  }

  activateEraser() {
    this.toolbarChangeActiveItem(ActiveItem.ERASER);
  }

  activateFreeHand() {
    if (!this.isActiveInterfaceItem(ActiveItem.FREE_HAND) && !this.isActiveInterfaceItem(ActiveItem.ERASER)) {
      this.toolbarChangeActiveItem(ActiveItem.FREE_HAND);
    }
  }

  drawingToolbar = false;
  uploadToolbar = false;
  shouldCloseAdditional = false;

  activateAdditionalToolbar(e: MouseEvent) {
    const target = e.currentTarget as HTMLElement;
    this.drawingToolbar = false;
    this.uploadToolbar = false;
    if (target.id === 'drawingButton') {
      this.drawingToolbar = true;
    } else if (target.id === 'uploadButton') {
      this.uploadToolbar = true;
    }
    this.activeAdditional = true;
    this.shouldCloseAdditional = false;
    this.calculateHelperToolbarPosition(target);
  }

  markToolbarForClosing() {
    this.shouldCloseAdditional = true;
    setTimeout(this.deactivateAdditionalToolbar, 500);
  }

  stopClosingToolbar() {
    this.shouldCloseAdditional = false;
  }

  deactivateAdditionalToolbar() {
    if (this.shouldCloseAdditional) {
      this.activeAdditional = false;
      this.drawingToolbar = false;
      this.uploadToolbar = false;
    }
  }

  toolbarTop = 0;

  calculateHelperToolbarPosition(target: HTMLElement) {
    const top = target.offsetTop + (target.parentElement?.offsetTop || 0) + target.clientHeight / 2;
    this.toolbarTop = top;
  }

  activateDrawingColor(color: string) {
    this.drawingColor = color;
    this.activateFreeHand();
  }

  activateDrawingThickness(thickness: string) {
    this.drawingThickness = thickness;
    this.activateFreeHand();
  }

  get scaleText() {
    return `${Math.floor(this.stageState.zoom * 100)}%`;
  }

  toggleLaserPointer() {
    if (this.isGuest) return;
    this.changeLaserActive(!this.interfaceLaserActive);
    if (this.interfaceLaserActive) {
      if (this.laserOfferedTo.isAccepted) {
        this.takeawayPointer();
      }
      this.activateLaserPointer();
    } else {
      this.deactivateLaserPointer();
    }
  }
}
